import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {AuthService} from "../auth.service";
import {UserService} from "@teammood/shared/util/user";
import { Router } from "@angular/router";

@Component({
    selector: 'logout',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogoutComponent implements OnInit {

    constructor(
        private authService: AuthService,
        private userService: UserService,
        private router: Router,
    ) { }

    async ngOnInit() {
        await this.authService.logout();
        this.userService.clear();
        setTimeout(async () => await this.router.navigateByUrl('/login'));
    }
}